import React, { useState, useEffect } from "react";
import { firestore } from "../config/firebase";
import { addDoc, collection, getDocs } from "firebase/firestore";
import "./dashboard.css";
import CircularProgress from "@mui/material/CircularProgress";
import { getDoc, setDoc, doc } from "firebase/firestore";
import counsellorDatas from "../counsellorData.json";
import advData from "../advertisementData.json";
import uniData from "../universityData.json";
import successData from "../successData.json";
const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [counsellorData, setCounsellorData] = useState({ total: 0, active: 0 });
  const [usersData, setUersData] = useState({ total: 0, active: 0 });

  useEffect(() => {
    const get_data = async () => {
      setLoading(true);
      let obj = {
        active: 0,
        total: 0,
      };

      let obj2 = {
        active: 0,
        total: 0,
      };

      try {
        const counsellorRef = collection(firestore, "councellors");
        const snapshot = await getDocs(counsellorRef);
        const usersRef = collection(firestore, "users");
        const snapshot2 = await getDocs(usersRef);
        obj2.total = snapshot2.size;
        obj.total = snapshot.size;
        snapshot.forEach((doc) => {
          const counselorData = doc.data();
          if (counselorData.status) {
            obj.active++;
          }
        });
        snapshot2.forEach((doc) => {
          const user = doc.data();
          if (user.status) {
            obj2.active++;
          }
        });
        console.log("obj2-----------------",obj2)
        setUersData(obj2);
        setCounsellorData(obj);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching active counsellors: ", error);
        alert("Some error occured while fetching data");
        setLoading(false);
      }
    };

    get_data();
  }, []);
  // const createCounsellor = async () => {
  //   let mapper = successData.map(async (e) => {
  //     // const counsellorRef = doc(firestore, "success_story", e.phone);
  //     await addDoc(collection(firestore, "success_story"), e);
  //     // await getDoc(counsellorRef);
  //     // await setDoc(counsellorRef, e);
  //   });
  //   let advDataMapper = advData.map(async (e) => {
  //     // const counsellorRef = doc(firestore, "success_story", e.phone);
  //     await addDoc(collection(firestore, "advertisements"), e);
  //     // await getDoc(counsellorRef);
  //     // await setDoc(counsellorRef, e);
  //   });
  //   let addUni = uniData.map(async (e) => {
  //     // const counsellorRef = doc(firestore, "success_story", e.phone);
  //     await addDoc(collection(firestore, "university"), e);
  //     // await getDoc(counsellorRef);
  //     // await setDoc(counsellorRef, e);
  //   });
  //   Promise.allSettled(addUni)
  //     .then((el) => {
  //       console.log("Add Uni Is Here---------------Success storycdsdvf", el);
  //     })
  //     .catch((err) => {
  //       console.log("Error in user UNI HERE------------advDataMapper");
  //     });
  //   Promise.allSettled(advDataMapper)
  //     .then((el) => {
  //       console.log("advDataMapper---------------Success story", el);
  //     })
  //     .catch((err) => {
  //       console.log("Error in user creation------------advDataMapper");
  //     });
  //   Promise.allSettled(mapper)
  //     .then((el) => {
  //       console.log("Logged---------------Success story", el);
  //     })
  //     .catch((err) => {
  //       console.log("Error in user creation------------");
  //     });
  // };
  return (
    <div>
      <div className="dashboard-heading-container">
        <span className="dashboard-heading">
          Welcome to Connect Overseas{" "}
        </span>
      </div>
      {loading ? (
        <div className="circular-progress">
          <CircularProgress size={30} />
        </div>
      ) : (
        <div className="card-container">
          <div className="card">
            <h2 className="card-title">Active Counsellors</h2>
            <p className="card-middle-text"> {counsellorData.active}</p>
            <p className="card-bottom-text">
              {" "}
              {((counsellorData.active / counsellorData.total) * 100).toFixed(
                2
              )}
              %
            </p>
          </div>
          <div className="card">
            <h2 className="card-title">Active Users</h2>
            <p className="card-middle-text">{usersData.active}</p>
            <p className="card-bottom-text">
              {" "}
              {((usersData.active / usersData.total) * 100).toFixed(2)}%
            </p>
          </div>
          <div className="card">
            <h2 className="card-title">Total Earnings</h2>
            <p className="card-middle-text">0</p>
            {/* <p class="card-bottom-text">This is the bottom text of the card.</p> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
